import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { SpinnerComponent } from './snipper/spinner-component';
import { DocumentStateServiceService } from './features/document-state.service.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,SpinnerComponent],
  template: '<app-spinner></app-spinner><router-outlet></router-outlet>',
  styles: []
})
export class AppComponent {
  constructor(
    private authService: AuthService,
    private documentStateService: DocumentStateServiceService
  ) { }
  ngOnInit() {
    this.authService.startup();
    //  NEW: re-apply saved theme/accent color on every app boot
    // (login AND page refresh) — previously this only ran right after
    // login, so an F5 reload lost the DOM attributes and fell back to
    // default light/indigo until the user visited settings again.
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      this.documentStateService.applyUserAppearance(JSON.parse(savedUser));
    }
  }
}